export class ImageProcess {
  process(url: string): string {
    if (url.includes('amazonaws.com/')) {
      return (
        `https://d258m6aalgmo9e.cloudfront.net/fit-in/800x600/` +
        url.split('amazonaws.com/')[1]
      )
    } else {
      return url
    }
  }
}
